import axios from 'axios';

import * as actionTypes from '../../types/reports';
import {
  getUsers,
  getReportsConfig,
  getReportsOrdersConfig,
  getReportsPaymentsChartConfig,
  getReportsPaymentsTableConfig,
  getReportsTicketsConfig,
  getReportsProfitsConfig, getReportsServicesConfig,
} from '../../../services/endpoints/reports';

/**
 * @function
 * @name getReportsConfigAction
 * @description Конфиг для страниц
 * @param {object} payload - Объект query листинга(фильтров)
 */
export const getReportsConfigAction = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_MAIN_CONFIG });

  try {
    const response = await getReportsConfig(payload);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_MAIN_CONFIG_SUCCESS,
      data,
    });

    return response;
  } catch (error) {
    dispatch({ type: actionTypes.GET_MAIN_CONFIG_ERROR, error });
    throw error;
  }
};

/**
 * @function
 * @name getReportsPaymentsTableConfigAction
 * @description Конфиг для страницы
 * @param {object} payload - Объект query листинга(фильтров)
 * @param {object} cancelToken - Объект для отмены запроса
 */
export const getReportsPaymentsTableConfigAction = (payload, cancelToken) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_PAGE_CONFIG });

  try {
    const response = await getReportsPaymentsTableConfig(payload, cancelToken);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_PAGE_CONFIG_SUCCESS,
      data,
    });

    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      return;
    }
    dispatch({ type: actionTypes.GET_PAGE_CONFIG_ERROR, error });
    throw error;
  }
};

/**
 * @function
 * @name getReportsPaymentsChartConfigAction
 * @description Конфиг для страницы
 * @param {object} payload - Объект query листинга(фильтров)
 * @param {object} cancelToken - Объект для отмены запроса
 */
export const getReportsPaymentsChartConfigAction = (payload, cancelToken) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_PAGE_CONFIG });

  try {
    const response = await getReportsPaymentsChartConfig(payload, cancelToken);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_PAGE_CONFIG_SUCCESS,
      data,
    });

    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      return;
    }
    dispatch({ type: actionTypes.GET_PAGE_CONFIG_ERROR, error });
    throw error;
  }
};

/**
 * @function
 * @name getReportsOrdersConfigAction
 * @description Конфиг для страницы
 * @param {object} payload - Объект query листинга(фильтров)
 * @param {object} cancelToken - Объект для отмены запроса
 */
export const getReportsOrdersConfigAction = (payload, cancelToken) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_PAGE_CONFIG });

  try {
    const response = await getReportsOrdersConfig(payload, cancelToken);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_PAGE_CONFIG_SUCCESS,
      data,
    });

    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      return;
    }
    dispatch({ type: actionTypes.GET_PAGE_CONFIG_ERROR, error });
    throw error;
  }
};

/**
 * @function
 * @name getReportsTicketsConfigAction
 * @description Конфиг для страницы
 * @param {object} payload - Объект query листинга(фильтров)
 * @param {object} cancelToken - Объект для отмены запроса
 */
export const getReportsTicketsConfigAction = (payload, cancelToken) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_PAGE_CONFIG });

  try {
    const response = await getReportsTicketsConfig(payload, cancelToken);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_PAGE_CONFIG_SUCCESS,
      data,
    });

    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      return;
    }
    dispatch({ type: actionTypes.GET_PAGE_CONFIG_ERROR, error });
    throw error;
  }
};

/**
 * @function
 * @name getReportsServicesConfigAction
 * @description Конфиг для страницы
 * @param {object} payload - Объект query листинга(фильтров)
 * @param {object} cancelToken - Объект для отмены запроса
 */
export const getReportsServicesConfigAction = (payload, cancelToken) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_PAGE_CONFIG });

  try {
    const response = await getReportsServicesConfig(payload, cancelToken);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_PAGE_CONFIG_SUCCESS,
      data,
    });

    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      return;
    }
    dispatch({ type: actionTypes.GET_PAGE_CONFIG_ERROR, error });
    throw error;
  }
};

/**
 * @function
 * @name getReportsProfitsConfigAction
 * @description Конфиг для страницы
 * @param {object} cancelToken - Объект для отмены запроса
 * @param {object} payload - Объект query листинга(фильтров)
 */
export const getReportsProfitsConfigAction = (payload, cancelToken) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_PAGE_CONFIG });

  try {
    const response = await getReportsProfitsConfig(payload, cancelToken);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_PAGE_CONFIG_SUCCESS,
      data,
    });

    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      return;
    }
    dispatch({ type: actionTypes.GET_PAGE_CONFIG_ERROR, error });
    throw error;
  }
};

/**
 * @function
 * @name getUsersList
 * @param {string} query - search string for request
 */
export const getUsersList = (query) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_USERS_LIST_SEARCH });

  try {
    const response = await getUsers(query);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_USERS_LIST_SEARCH_SUCCESS,
      data,
    });

    return data;
  } catch (error) {
    dispatch({ type: actionTypes.GET_USERS_LIST_SEARCH_ERROR, error });
  }
};

export const setPageFilters = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.SET_PAGE_FILTERS, payload });
};

export const setPageData = (payload) => async (dispatch) => dispatch({ type: actionTypes.SET_PAGE_DATA, payload });

export const setPageFiltersType = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.SET_PAGE_FILTERS_TYPE, payload });
};

export const setPageFiltersQuery = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.SET_PAGE_FILTERS_QUERY, payload });
};

export const setPageLoader = (payload) => (dispatch) => {
  dispatch({ type: actionTypes.SET_PAGE_LOADER, payload });
};

export const setPageClearData = () => async (dispatch) => {
  dispatch({ type: actionTypes.SET_PAGE_CLEAR_PAGE_DATA });
};
